import React from "react";
import PropTypes from "prop-types";

class ResultsAnnouncement extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
  };

  state = {
    message: "",
  };

  componentDidMount() {
    this.announce();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.message !== this.props.message) {
      this.announce();
    }
  }

  componentWillUnmount() {
    clearTimeout(this._announcementTimeout);
  }

  announce() {
    clearTimeout(this._announcementTimeout);
    this.setState({ message: "" });
    this._announcementTimeout = setTimeout(() => {
      this.setState({ message: this.props.message });
    }, 100);
  }

  render() {
    return (
      <div
        aria-live="assertive"
        aria-atomic="true"
        className="th-sr-only">
        {this.state.message}
      </div>
    );
  }
}

export default ResultsAnnouncement;
